module.exports = __webpack_public_path__ + "img/tr.52a3b694.png";